import React from 'react';
import { Card, CardHeader, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';
import { crmData } from '../../data/crmData';
import { useNavigate } from 'react-router-dom';

export const ConsultantDashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-8 pb-20">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-2xl font-black text-slate-900 uppercase tracking-tight">Consultant Dashboard</h1>
          <p className="text-slate-500 mt-1 uppercase text-[10px] font-bold tracking-widest italic">Portfolio Management</p>
        </div>
        <Button variant="primary" icon={<SafeIcon name="Plus" />} onClick={() => navigate('/dashboard/assessments')}>Ny Kartlegging</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { label: 'Kunder i Risiko', val: '2', color: 'rose', icon: 'AlertTriangle' },
          { label: 'Aktive Prosjekter', val: '12', color: 'indigo', icon: 'Briefcase' },
          { label: 'Fullførte Svar', val: '450+', color: 'emerald', icon: 'CheckCircle' }
        ].map((s, i) => (
          <Card key={i}>
            <CardContent className="p-6 flex items-center gap-4">
              <div className={`w-12 h-12 rounded-2xl bg-${s.color}-50 text-${s.color}-600 flex items-center justify-center`}>
                <SafeIcon name={s.icon} />
              </div>
              <div>
                <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{s.label}</p>
                <p className="text-2xl font-black text-slate-900">{s.val}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <Card>
            <CardHeader title="Kundeoversikt & Risiko" action={<Button variant="ghost" size="sm">Se alle</Button>} />
            <CardContent className="p-0">
              <div className="overflow-x-auto">
                <table className="w-full text-left">
                  <thead className="bg-slate-50 border-b border-slate-100">
                    <tr className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                      <th className="px-6 py-4">Kunde</th>
                      <th className="px-6 py-4">Helse</th>
                      <th className="px-6 py-4">Status</th>
                      <th className="px-6 py-4 text-right">Handling</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-50">
                    {crmData.clients.map((client) => (
                      <tr key={client.id} className="hover:bg-slate-50/50 transition-colors">
                        <td className="px-6 py-4">
                          <p className="font-bold text-slate-900">{client.name}</p>
                          <p className="text-[10px] text-slate-400">{client.industry}</p>
                        </td>
                        <td className="px-6 py-4">
                          <span className={`text-sm font-black ${client.healthScore < 50 ? 'text-rose-500' : 'text-emerald-500'}`}>{client.healthScore}%</span>
                        </td>
                        <td className="px-6 py-4">
                           <div className={`w-2 h-2 rounded-full ${client.healthScore < 50 ? 'bg-rose-500' : client.healthScore < 70 ? 'bg-amber-400' : 'bg-emerald-500'}`} />
                        </td>
                        <td className="px-6 py-4 text-right">
                          <Button variant="ghost" size="sm" icon={<SafeIcon name="ArrowRight" />} onClick={() => navigate('/dashboard/health')} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="space-y-6">
          <Card className="bg-indigo-900 border-none text-white">
            <CardHeader title="Intervensjonsforslag" icon={<SafeIcon name="Zap" className="text-indigo-400" />} />
            <CardContent className="space-y-4">
              {[
                { title: "Team-workshop", client: "Nordic Retail", type: "Mekling" },
                { title: "Ledercoaching", client: "TechCorp AS", type: "Stress" }
              ].map((inv, i) => (
                <div key={i} className="p-4 bg-white/5 rounded-2xl border border-white/10">
                  <p className="text-[9px] font-black text-indigo-300 uppercase mb-1">{inv.client}</p>
                  <h5 className="font-bold text-white text-sm">{inv.title}</h5>
                  <Button variant="ghost" size="sm" className="mt-2 p-0 text-indigo-400 hover:text-white">Planlegg →</Button>
                </div>
              ))}
            </CardContent>
          </Card>
          <Card>
            <CardHeader title="Konsulentverktøy" />
            <CardContent className="grid grid-cols-2 gap-3">
              {[
                { label: 'Rapport', icon: 'FileText', path: '/dashboard/reports' },
                { label: 'Workshops', icon: 'Users', path: '/dashboard/workshops' },
                { label: 'Diagnose', icon: 'Zap', path: '/dashboard/diagnosis' },
                { label: 'Planer', icon: 'Target', path: '/dashboard/90-day-plan' }
              ].map((tool, i) => (
                <button key={i} onClick={() => navigate(tool.path)} className="p-4 bg-slate-50 rounded-2xl border border-slate-100 hover:bg-indigo-50 hover:border-indigo-200 transition-all text-center group">
                  <SafeIcon name={tool.icon} className="mx-auto mb-2 text-slate-400 group-hover:text-indigo-600" />
                  <span className="text-[10px] font-black text-slate-500 uppercase group-hover:text-indigo-600">{tool.label}</span>
                </button>
              ))}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};